/* eslint new-cap: 0 */

import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';
import Video from './Video';
import Image from 'components/Image';

class VideoThumbnail extends Component {
  static propTypes = {
    title: PropTypes.string,
    clipId: PropTypes.string,
    thumbnailUri: PropTypes.string,
    autoPlay: PropTypes.bool
  }

  state = {
    showVideo: false
  }

  _handleClick() {
    this.setState({
      showVideo: true
    });
  }

  _handleVideoHide() {
    this.setState({
      showVideo: false
    });
  }

  render() {
    const { thumbnailUri, title, clipId, autoPlay } = this.props;
    const { showVideo } = this.state;

    return (
      <div className="VideoThumbnail" onClick={() => this._handleClick()}>
        <Modal
          show={showVideo}
          onHide={() => this._handleVideoHide()}
          bsSize="large"
          backdrop
          aria-labelledby="contained-modal-title-lg"
          >
          { title ?
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">{title}</Modal.Title>
            </Modal.Header>
            : null
          }
          <Modal.Body>
            <Video clipId={clipId} autoPlay={autoPlay} />
          </Modal.Body>
        </Modal>
        {thumbnailUri ? <Image imageClassNames="VideoThumbnail-image" width="215" src={thumbnailUri} alt={'Video thumbnail image' + (title ? ' for ' + title : '')} /> : <div className="VideoThumbnail-thumbnailPlaceholder" />}
      </div>
    );
  }

}

export default VideoThumbnail;



// WEBPACK FOOTER //
// ./app/components/media/VideoThumbnail.js